var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.html)?_c('div',{staticClass:"G-row U-justify-content-center"},[_c('div',{staticClass:"G-col-auto",class:_vm.getSettings.className,domProps:{"innerHTML":_vm._s(_vm.data.html)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }